import React from "react";
import {
  ComponentAdditionPageContent,
  ComponentAdditionPageStateProvider,
} from ".";

export const ComponentAdditionPage = () => {
  return (
    <ComponentAdditionPageStateProvider>
      <ComponentAdditionPageContent />
    </ComponentAdditionPageStateProvider>
  );
};
